(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 93027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return __webpack_require__(21145);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33838);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);



const Link = (param)=>{
    let { href , color ="secondary" , onClick , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
        as: (next_link__WEBPACK_IMPORTED_MODULE_1___default()),
        href: href || "#",
        passHref: true,
        color: color,
        onClick: onClick ? (e)=>{
            e.preventDefault();
            onClick(e);
        } : undefined,
        ...props,
        children: children
    });
};
Link.displayName = "Link";


/***/ }),

/***/ 49441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36979);


const Container = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W, {
        ...props,
        children: children
    });
};
Container.displayName = "Container";


/***/ }),

/***/ 91003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95034);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88911);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24804);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(204);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36953);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66303);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46887);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40989);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53854);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20956);
/* harmony import */ var _components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41151);







const Header = (param)=>{
    let { title , ...props } = param;
    const left = title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderLogo, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Spacer */ .L, {});
    const center = title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
        textAlign: "center",
        color: "white",
        children: title
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderLogoHorizontal, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .U, {
        h: "50px",
        position: "sticky",
        top: 0,
        left: 0,
        right: 0,
        bg: "base",
        paddingX: 4,
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
                flexBasis: "50px",
                justifyContent: "flex-start",
                children: left
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
                flex: 1,
                justifyContent: "center",
                children: center
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
                flexBasis: "50px",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderMenu, {})
            })
        ]
    });
};
const HeaderLogo = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r, {
        href: "/",
        lineHeight: 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "/images/logoWhite.png",
            width: 32,
            height: 32,
            alt: "トレーニングシェア"
        })
    });
};
const HeaderLogoHorizontal = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r, {
        href: "/",
        lineHeight: 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "/images/logoHorizontal.png",
            width: 142,
            height: 32,
            alt: "トレーニングシェア"
        })
    });
};
const HeaderMenu = ()=>{
    const { isAuthenticated , isActionRequired  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const isGuest = !isAuthenticated && !isActionRequired;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Menu */ .v, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .MenuButton */ .j, {
                "aria-label": "メニュー",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_11__/* .HiMenu */ .r0I, {
                    color: "white",
                    size: 28
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .MenuList */ .q, {
                children: [
                    isGuest && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/"),
                                children: "トップページ"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/signup"),
                                children: "メールアドレスで登録"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/signin"),
                                children: "ログイン"
                            })
                        ]
                    }),
                    isAuthenticated && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/top?howToUse=open"),
                                children: "トレーニングシェアとは"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/news"),
                                children: "新着情報一覧"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/glossary"),
                                children: "用語集"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/profile"),
                                children: "プロフィール編集"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/credit_card"),
                                children: "クレジットカード変更"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                        onClick: ()=>router.push("/contact"),
                        children: "お問い合わせ"
                    }),
                    !isGuest && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                        onClick: ()=>router.push("/signout"),
                        children: "ログアウト"
                    })
                ]
            })
        ]
    });
};
Header.displayName = "Header";


/***/ }),

/***/ 45564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SubHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23100);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24804);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88911);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8193);
/* harmony import */ var _components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41151);





const SubHeader = (param)=>{
    let { backTo  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const handleClick = ()=>{
        if (window.history.length <= 1) {
            router.push(backTo);
        } else {
            router.back();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        paddingY: 4,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
            onClick: handleClick,
            color: "textDark",
            display: "inline-block",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .U, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_5__/* .AiOutlineArrowLeft */ .kyg, {
                        size: 22
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                        fontSize: "sm",
                        children: "戻る"
                    })
                ]
            })
        })
    });
};
SubHeader.displayName = "SubHeader";


/***/ }),

/***/ 85782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23100);


const Wrapper = (param)=>{
    let { header , footer , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        children: [
            header,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                pb: footer ? 20 : 4,
                children: children
            }),
            footer
        ]
    });
};
Wrapper.displayName = "Wrapper";


/***/ }),

/***/ 96981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Title; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const Title = (param)=>{
    let { title , override =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: "\n          ".concat(title, "\n          ").concat(override ? "" : "｜トレーニングシェア", "\n        ")
        })
    });
};


/***/ }),

/***/ 21145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ privacy; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-QLVBORJB.mjs
var chunk_QLVBORJB = __webpack_require__(90634);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-P74GIWPW.mjs
var chunk_P74GIWPW = __webpack_require__(88911);
// EXTERNAL MODULE: ./components/layouts/Container/Container.tsx
var Container = __webpack_require__(49441);
// EXTERNAL MODULE: ./components/layouts/Header/Header.tsx
var Header = __webpack_require__(91003);
// EXTERNAL MODULE: ./components/layouts/SubHeader/SubHeader.tsx
var SubHeader = __webpack_require__(45564);
// EXTERNAL MODULE: ./components/layouts/Wrapper/Wrapper.tsx
var Wrapper = __webpack_require__(85782);
// EXTERNAL MODULE: ./components/metas/Title/Title.tsx
var Title = __webpack_require__(96981);
;// CONCATENATED MODULE: ./components/pages/PrivacyPolicyPage.tsx







const PrivacyPolicyPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* Wrapper */.i, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
            title: "個人情報保護方針"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                title: "個人情報保護方針"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader/* SubHeader */.b, {
                        backTo: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_QLVBORJB/* VStack */.g, {
                        spacing: 6,
                        my: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                fontWeight: "bold",
                                fontSize: "lg",
                                children: "個人情報保護方針"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_QLVBORJB/* VStack */.g, {
                                spacing: 4,
                                alignItems: "stretch",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "はじめに"
                                            }),
                                            "株式会社IMPRINT（以下「当社」といいます）は、当社が運営するトレーニング情報管理共有サービス「トレーニングシェア」において提供するサービス（情報提供、コンテンツ提供、トレーニング情報管理システム、オンラインレッスン、イベント、お問い合わせ等）の円滑な運営に必要な範囲で、トレーニングシェアを利用されるお客様の個人情報をお預かりしております。当社は個人情報を保護し、お客様に更なる信頼性と安心感をご提供できるように努めて参ります。",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "当社は、個人情報に関する法令を遵守し、個人情報の適切な取り扱いを実現致します。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "1. 個人情報の取得について"
                                            }),
                                            "当社は、偽りその他不正の手段によらず適正に個人情報を取得致します。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "2. 個人情報の利用について"
                                            }),
                                            "当社は、個人情報を以下の利用目的の達成に必要な範囲内で、利用致します。",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "以下に定めのない目的で個人情報を利用する場合、あらかじめご本人の同意を得た上で行います。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "個人情報の利用目的"
                                            }),
                                            "（1）当社が運営し、管理する「トレーニングシェア」の会員登録手続きのため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（2）「トレーニングシェア」で共有するプロフィール、トレーニング情報等掲載のため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（3）「トレーニングシェア」で提供する情報、サービスに関するお問合わせにお応えするため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（4）「トレーニングシェア」で企画・運営するイベントやオンラインレッスン等のお申し込み手続きのため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（5）「トレーニングシェア」で提供する情報やコンテンツの購入手続きのため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（6）「トレーニングシェア」で提供するトレーニング情報管理システム利用手続きのため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（7）「トレーニングシェア」のサービス関するご案内、コンテンツ、イベント、オンラインレッスン、セミナー等に関するメールマガジンやダイレクトメールをお送りするため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（8）「トレーニングシェア」のサービスに関するアンケートをお送りするため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（9）クレジットカード決済手続きのため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（10）お問合せ時のご本人確認ならびに内容確認のため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（11）イベント、オンラインレッスン等開催時のご本人確認のため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "（12）その他お客様に事前に通知または公表した目的のため",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "上記以外の目的で個人情報を収集して利用する際には、その利用目的とお問合せ先を明示します。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "3. 個人情報の安全管理について"
                                            }),
                                            "当社は、取り扱う個人情報の漏洩、滅失または毀損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "4. 個人情報の委託について"
                                            }),
                                            "当社は、個人情報の取り扱いの全部または一部を第三者に委託する場合は、当該第三者について厳正な調査を行い、取り扱いを委託された個人情報の安全管理が図られるよう当該第三者に対する必要かつ適切な監督を行います。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "5. 個人情報の第三者提供について"
                                            }),
                                            "当社は、個人情報保護法等の法令に定めのある場合を除き、個人情報をあらかじめご本人の同意を得ることなく、第三者に提供致しません。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "6. 個人情報の開示・訂正等について"
                                            }),
                                            "当社は、ご本人から自己の個人情報についての開示の請求がある場合、速やかに開示を致します。",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "その際、ご本人であることが確認できない場合には、開示に応じません。",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "個人情報の内容に誤りがあり、ご本人から訂正・追加・削除の請求がある場合、調査の上、速やかにこれらの請求に対応致します。",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "その際、ご本人であることが確認できない場合には、これらの請求に応じません。",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "当社の個人情報の取り扱いにつきまして、上記の請求・お問い合わせ等ございましたら、下記までご連絡くださいますようお願い申し上げます。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            "連絡先",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "株式会社IMPRINT",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "E-mail：info@imprint.jp",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "電話：03-6452-5858　FAX：03-6452-5859"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                                                fontWeight: "bold",
                                                children: "7. 本方針の変更 本方針の内容は変更されることがあります。"
                                            }),
                                            "変更後の本方針については、当社が別途定める場合を除いて、当サイトに掲載した時から効力を生じるものとします。"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                        fontSize: "sm",
                                        children: [
                                            "制定日：2021年7月1日",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "株式会社IMPRINT",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "代表取締役　北島康介"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_PrivacyPolicyPage = (PrivacyPolicyPage);

;// CONCATENATED MODULE: ./pages/privacy.tsx


const Privacy = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_PrivacyPolicyPage, {});
};
/* harmony default export */ var privacy = (Privacy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6556,4617,1191,5982,9059,9774,2888,179], function() { return __webpack_exec__(93027); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);